import { Row, Data } from './styles';
import { EditIcon, DeleteOutlineIcon } from 'icons';

import {
  ActionButton,
} from 'components';
import { Observation } from './observationTable';

interface ObservationRowProps {
  item: Observation;
  onEdit: (item: Observation) => void;
  onDelete: (item: Observation) => void;
}

export function ObservationRow({ item, onEdit, onDelete }: Readonly<ObservationRowProps>): JSX.Element {
  return (
    <Row>
      <Data>{item.OBS_DESC}</Data>
      <Data>{new Date(item.date).toLocaleString('pt-BR')}</Data>
      <Data>{item.userId}</Data>
      <Data>
        <ActionButton onClick={() => onEdit(item)} variant="blue-inv">
          <EditIcon width="18px" />
        </ActionButton>
        <ActionButton onClick={() => onDelete(item)} variant="red-inv">
          <DeleteOutlineIcon />
        </ActionButton>
      </Data>
    </Row>
  );
}
